import { createStoreCreator } from 'lib/store'
import reducer from 'reports/scrapPareto/reducers'

export default createStoreCreator(reducer)
